import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Comissao } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ComissaoService extends BaseResourceService<Comissao> {

  constructor(
    protected injector: Injector
  ) {
    super(`comissoes`, injector);
  }

}
